import React from 'react';
import { DialogActions, Button, Box } from '@mui/material';

interface DialogActionButtonsProps {
    isEditMode: boolean;
    isSubmitDisabled: boolean;
    onDelete?: () => void;
    onCancel: () => void;
    onSave: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
    isEditMode,
    isSubmitDisabled,
    onDelete,
    onCancel,
    onSave
}) => {
    return (
        <DialogActions>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Box>
                    {isEditMode && onDelete && (
                        <Button
                            onClick={onDelete}
                            color="error"
                            variant="outlined"
                        >
                            Delete
                        </Button>
                    )}
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button onClick={onCancel} variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        onClick={onSave}
                        variant="contained"
                        disabled={isSubmitDisabled}
                    >
                        {isEditMode ? 'Update' : 'Add'}
                    </Button>
                </Box>
            </Box>
        </DialogActions>
    );
};
